import { Injectable } from '@angular/core';
import { IFilterNotFormatted } from '../interfaces/filter';
import { ISortColumn } from '../../../shared/interfaces/table';

@Injectable({
  providedIn: 'root'
})
export class OperationFilterStateService {
  private filterState: IFilterNotFormatted | null = null;
  private sort: ISortColumn | null = null;

  setFilterState(filter: IFilterNotFormatted) {
    this.filterState = filter;
  }

  getFilterStateValue() {
    return this.filterState;
  }

  getSort() {
    return this.sort;
  }

  setSort(sort: ISortColumn) {
    this.sort = sort;
  }

  clear() {
    this.filterState = null;
    this.sort = null;
  }
}
